import { CheckboxField as CheckboxElement } from '@treneo/shared/forms';
import { useAppTranslations } from '@treneo/shared/i18n';

import { courseFormFieldNames } from '../course-form-field-names';
import { CheckboxSection } from '../styled';

type Props = {
  isEdit: boolean;
};

export const CheckboxOptionsSection = ({ isEdit }: Readonly<Props>) => {
  const { t } = useAppTranslations();

  return (
    <CheckboxSection>
      <CheckboxElement
        name={courseFormFieldNames.wantToBeCoordinator}
        label={t('courseForm.wantToBeCoordinator')}
      />
      <CheckboxElement
        name={courseFormFieldNames.isDemo}
        label={t('courseForm.isDemo')}
        disabled={isEdit}
      />
    </CheckboxSection>
  );
};
